var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCloseCircle = function SvgCloseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#close-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.093 4.364c-4.73 4.73-4.73 12.395 0 17.125s12.395 4.73 17.125 0 4.73-12.395 0-17.125-12.395-4.73-17.125 0Zm14.5 4.558c.229.228.229.6 0 .828l-3.176 3.177 3.177 3.176c.228.228.228.601 0 .829l-1.934 1.933a.588.588 0 0 1-.828 0l-3.177-3.176-3.176 3.176a.588.588 0 0 1-.829 0l-1.933-1.933a.588.588 0 0 1 0-.829l3.176-3.176L6.717 9.75a.588.588 0 0 1 0-.828L8.65 6.988a.588.588 0 0 1 .829 0l3.176 3.177 3.177-3.177a.588.588 0 0 1 .828 0l1.934 1.934Z",
    fill: "gray"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "close-circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.155 .427)",
    d: "M0 0h25v25H0z"
  })))));
};
export default SvgCloseCircle;